const DEFAULT_ROBOTS =
  'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';

function setMetaByName(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

type SEOOptions = {
  title: string;
  description: string;
  /** true = 404 e similares; false/omitido = reativa indexação após sair do 404 */
  noIndex?: boolean;
};

// Função utilitária para SEO dinâmico
export function setSEO({ title, description, noIndex }: SEOOptions) {
  if (typeof document === 'undefined') return;
  if (title) document.title = title;
  if (description) {
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', description);
  }
  if (noIndex) {
    setMetaByName('robots', 'noindex, nofollow');
    setMetaByName('googlebot', 'noindex, nofollow');
  } else {
    setMetaByName('robots', DEFAULT_ROBOTS);
    setMetaByName('googlebot', DEFAULT_ROBOTS);
  }
} 